module.exports = __webpack_public_path__ + "img/logo.3b97f6b3.jpg";